import JsBarcode from "jsbarcode";
import QRCode from "qrcode";
import type { BarcodeElement, QrCodeElement } from "../core/types";

export function renderBarcodeSvg(element: BarcodeElement): string {
  const svgNode = document.createElementNS("http://www.w3.org/2000/svg", "svg");

  JsBarcode(svgNode, element.value, {
    format: element.format ?? "CODE128",
    displayValue: element.displayValue ?? false,
    lineColor: element.lineColor ?? "#111827",
    background: element.background ?? "transparent",
    width: element.width ?? 2,
    height: element.height ?? 64,
    margin: element.margin ?? 0,
    xmlDocument: document
  });

  return svgNode.outerHTML;
}

export async function renderQrCodeSvg(element: QrCodeElement): Promise<string> {
  return QRCode.toString(element.value, {
    type: "svg",
    width: element.size ?? 128,
    color: {
      dark: element.darkColor ?? "#111827",
      light: element.lightColor ?? "#ffffff"
    },
    margin: element.margin ?? 0
  });
}
